<template>
  <div class="p-15">
    <el-form ref="ruleForm" :model="submitForm" :rules="rules" label-width="auto">
      <el-card header="基本信息">
        <el-form-item label="礼品相册" prop="photoUrls">
          <uploader @success="success" @remove="remove" :file-list="fileList" list-type="picture-card" show-file-list></uploader>
        </el-form-item>
        <el-form-item label="礼品类型" prop="type">
          <gift-type @input="submitForm.takeType = undefined" v-model="submitForm.type"></gift-type>
        </el-form-item>
        <!--        <el-form-item v-if="submitForm.type==='invented'" label="虚拟类型" prop="childType">-->
        <!--          <gift-child-type v-model="submitForm.childType"></gift-child-type>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="礼品分类" prop="categoryId">-->
        <!--          <gift-category v-model="submitForm.categoryId"></gift-category>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="礼品分类" prop="categoryId">-->
        <!--          <gift-category v-model="submitForm.categoryId"></gift-category>-->
        <!--        </el-form-item>-->
        <el-form-item label="礼品名称" prop="title">
          <el-input v-model.trim="submitForm.title" placeholder="请输入礼品名称，不超过30字" :maxlength="30" show-word-limit class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="礼品编码" prop="code">
          <el-input v-model.trim="submitForm.code" placeholder="请输入礼品编码" class="el-input-cover"></el-input>
        </el-form-item>
        <el-form-item label="礼品规格" prop="attr">
          <el-input v-model.trim="submitForm.attr" placeholder="请输入礼品规格，不超过20字" :maxlength="20" show-word-limit class="el-input-cover"></el-input>
        </el-form-item>
      </el-card>
      <el-card header="发货设置" class="m-t-20">
        <el-form-item label="收货方式" prop="takeType">
          <el-radio-group v-model="submitForm.takeType">
            <el-radio v-for="item in GIFT_TYPE.entityTakeList[submitForm.type]" :label="item.value" :key="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--        <el-form-item label="发货方式">-->
        <!--          <el-input v-model="submitForm.shipments" placeholder="请输入发货API" class="el-input-cover"></el-input>-->
        <!--        </el-form-item>-->
      </el-card>
      <el-card class="m-t-20">
        <el-form-item label-width="0" prop="desc">
          <Tinymce ref="tinymce" v-model="submitForm.desc"></Tinymce>
        </el-form-item>
        <div class="m-t-20">
          <el-button @click="submit" type="primary" :loading="loading">立即提交</el-button>
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import giftType from '@/views/Gift/components/gift-type'
import giftCategory from '@/views/Gift/components/gift-category'
import Tinymce from '@/components/Tinymce'
import { GIFT_TYPE } from '@/enums/gift'
import { createGift, giftDocument, updateGift } from '@/api/gift'

export default {
  name: 'detail',
  components: {
    giftType,
    giftCategory,
    Tinymce
  },
  computed: {
    fileList() {
      return this.submitForm.photoUrls.map(item => {
        return {
          name: undefined,
          url: item
        }
      })
    }
  },
  data() {
    return {
      loading: false,

      submitForm: {
        title: undefined,
        type: 'entity',
        categoryId: undefined,
        code: undefined,
        attr: undefined,
        takeType: undefined,
        shipments: undefined,
        desc: '',
        photoUrls: []
      },
      rules: {
        title: [{ required: true, message: '请输入礼品名称', trigger: 'blur' }],
        desc: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        type: [{ required: true, message: '请选择礼品类型', trigger: 'change' }],
        categoryId: [{ required: true, message: '请选择礼品分类', trigger: 'change' }],
        code: [{ required: true, message: '请输入礼品编码', trigger: 'blur' }],
        attr: [{ required: true, message: '请输入礼品规格', trigger: 'blur' }],
        takeType: [{ required: true, message: '请选择收货方式', trigger: 'blur' }],
        photoUrls: [{ type: 'array', required: true, message: '请上传礼品相册图片', trigger: ['blur', 'change'] }]
      },

      GIFT_TYPE
    }
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            this.submitForm.id ? await updateGift(this.submitForm) : await createGift(this.submitForm)
            this.$message.success('操作成功')
            this.$refs.ruleForm.resetFields()
            this.$refs.tinymce.setContent('')
            this.$router.back()
          } finally {
            this.loading = false
          }
        }
      })
    },
    success(data, customList) {
      this.submitForm.photoUrls = customList.map(item => item.url)
    },
    remove(fileList) {
      this.submitForm.photoUrls = fileList
    }
  },
  async mounted() {
    const { id } = this.$route.query
    if (id) {
      const { document } = await giftDocument(id)
      this.submitForm = { ...document }
    }
  }
}
</script>

<style scoped></style>
